/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Uno_Confirm_Change_NameInputs */



/**
* | output |
* | --- |
* | "rename it to “{name}”" |
*
* @param {Uno_Confirm_Change_NameInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_confirm_change_name = /** @type {((inputs: Uno_Confirm_Change_NameInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Confirm_Change_NameInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`umbenennen in „${i?.name}“`)
	return /** @type {LocalizedString} */ (`rename it to “${i?.name}”`)
});